
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ItineraryTagSelector } from '@/components/itinerary/ItineraryTagSelector';

interface BlogTagsTabProps {
  selectedTagIds: string[];
  onChange: (ids: string[]) => void;
}

export function BlogTagsTab({ selectedTagIds, onChange }: BlogTagsTabProps) {
  return (
    <Card className="glass-card">
      <CardHeader>
        <CardTitle>Tags</CardTitle>
        <CardDescription>
          Categorize this blog post with relevant tags
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ItineraryTagSelector 
          selectedTagIds={selectedTagIds}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
}
